import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引入全局公共样式
import '@/assets/style/common.css'
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')